<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">资产调拨</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <asset-allot ref="create" :userData="userData" :formByFather="form"></asset-allot>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsers.c111" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>
          </div>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitAsset()" class="form-btn" type="success">确认提交资产调拨单
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import ApprovalItem from '@/components/ApprovalItem'
  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'
  import Attachments from '@/components/Attachments'
  import AssetAllot from '@/page/form/asset/allot'
  export default {
    components: {
      ApprovalItem,
      AssetAllot,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        depId: '',
        formLoading: false,
        organizationListData: [],

        form: {
          assetIds: [],
          depId: '',
          reason: '',
          inDepId: '',
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      // this.form.time = this.getNowTime()
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1


      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      } else {
        this.setSelectArr(this.applyInfo, 111)
      }

    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/asset/allot/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.depId = this.form.department.id
          this.form.inDepId = this.form.inDepartment.id

          this.form.applyId = this.form.flow.applyId

          this.form.json = true

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, 111)
          this.formLoading = false
        })
      },
      // 提交资产调拨单
      SubmitAsset() {
        this.form = this.$refs.create.getFromData()
        if (!this.form.depId) {
          this.$message.error("请先选择资产调入公司")
          return
        }
        if (this.form.depId == this.form.assetDepId) {
          this.$message.error("调入公司与调出公司不能是同一个公司")
          return
        }
        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/asset/allot/apply' : '/asset/allot/apply/edit?applyId=' + this.form
          .applyId
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交资产调拨成功申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改资产调拨成功申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Asset/AllotList')
        }, (res) => {
          this.formLoading = false
        })
      },

    },
    watch: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/allot.vue